export default __webpack_public_path__ + "static/media/attach_file_24px.31a9d533.svg";